<template>
    <div class="o-page">
        <div class="o-layout">
            <c-sidebar></c-sidebar>
            <div @click="closeSidebar()" class="o-sidebar__overlay"></div>
            <div class="o-content">
                <c-topbar :class="{'o-topbar--hide-desktop' : !this.$route.meta.topbar}"></c-topbar>
                <router-view></router-view>
            </div>
        </div>
        <c-toast-container></c-toast-container>
        <c-confirm-container></c-confirm-container>
    </div>
</template>

<script>
import CSidebar from '@components/layout/Sidebar';
import CTopbar from '@components/layout/Topbar';
import CToastContainer from '@components/toast/Container';
import CConfirmContainer from '@components/confirm/Container';

export default {
    components: { CSidebar, CTopbar, CToastContainer, CConfirmContainer },
    methods: {
        closeSidebar () {
            this.$root.$emit('close-sidebar');
        }
    },
    beforeCreate() {
        this.$store.dispatch('preferences/load');
    }
}
</script>
